// Get user agent
function getUserAgent(context) {
    var _context_navigator;
    if (context == null ? void 0 : (_context_navigator = context.navigator) == null ? void 0 : _context_navigator.userAgent) return context.navigator.userAgent;
    return navigator.userAgent || "";
}
// Get language
function getLanguage(context) {
    var _context_navigator, _navigator_languages;
    if (context == null ? void 0 : (_context_navigator = context.navigator) == null ? void 0 : _context_navigator.language) return context.navigator.language;
    return navigator.language || ((_navigator_languages = navigator.languages) == null ? void 0 : _navigator_languages[0]) || null;
}
// Get color depth
function getColorDepth(context) {
    var _context_window_screen, _context_window;
    if (context == null ? void 0 : (_context_window = context.window) == null ? void 0 : (_context_window_screen = _context_window.screen) == null ? void 0 : _context_window_screen.colorDepth) return context.window.screen.colorDepth;
    return window.screen.colorDepth || 0;
}
// Get device memory
function getDeviceMemory(context) {
    if ((context == null ? void 0 : context.navigator) && "deviceMemory" in context.navigator) {
        return context.navigator.deviceMemory || null;
    }
    return navigator.deviceMemory || null;
}
// Get hardware concurrency (CPU cores)
function getHardwareConcurrency(context) {
    var _context_navigator;
    if (context == null ? void 0 : (_context_navigator = context.navigator) == null ? void 0 : _context_navigator.hardwareConcurrency) return context.navigator.hardwareConcurrency;
    return navigator.hardwareConcurrency || null;
}
// Get screen resolution
function getScreenResolution(detectScreenOrientation = true, context) {
    var _context_window_screen, _context_window, _context_window_screen1, _context_window1;
    let width = (context == null ? void 0 : (_context_window = context.window) == null ? void 0 : (_context_window_screen = _context_window.screen) == null ? void 0 : _context_window_screen.width) || window.screen.width;
    let height = (context == null ? void 0 : (_context_window1 = context.window) == null ? void 0 : (_context_window_screen1 = _context_window1.screen) == null ? void 0 : _context_window_screen1.height) || window.screen.height;
    if (detectScreenOrientation && width > height) {
        [width, height] = [
            height,
            width
        ];
    }
    return `${width}x${height}`;
}
// Get available screen resolution
function getAvailableScreenResolution(detectScreenOrientation = true, context) {
    var _context_window_screen, _context_window, _context_window_screen1, _context_window1;
    let width = (context == null ? void 0 : (_context_window = context.window) == null ? void 0 : (_context_window_screen = _context_window.screen) == null ? void 0 : _context_window_screen.availWidth) || window.screen.availWidth;
    let height = (context == null ? void 0 : (_context_window1 = context.window) == null ? void 0 : (_context_window_screen1 = _context_window1.screen) == null ? void 0 : _context_window_screen1.availHeight) || window.screen.availHeight;
    if (detectScreenOrientation && width > height) {
        [width, height] = [
            height,
            width
        ];
    }
    return `${width}x${height}`;
}
// Get timezone offset
function getTimezoneOffset(context) {
    return new Date().getTimezoneOffset();
}
// Get timezone
function getTimezone(context) {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (e) {
        return null;
    }
}
// Check session storage availability
function hasSessionStorage(context) {
    try {
        var _context_window;
        return !!((context == null ? void 0 : (_context_window = context.window) == null ? void 0 : _context_window.sessionStorage) || window.sessionStorage);
    } catch (e) {
        return false;
    }
}
// Check local storage availability
function hasLocalStorage(context) {
    try {
        var _context_window;
        return !!((context == null ? void 0 : (_context_window = context.window) == null ? void 0 : _context_window.localStorage) || window.localStorage);
    } catch (e) {
        return false;
    }
}
// Check IndexedDB availability
function hasIndexedDB(context) {
    try {
        var _context_window;
        return !!((context == null ? void 0 : (_context_window = context.window) == null ? void 0 : _context_window.indexedDB) || window.indexedDB);
    } catch (e) {
        return false;
    }
}
// Get CPU class
function getCpuClass(context) {
    if ((context == null ? void 0 : context.navigator) && "cpuClass" in context.navigator) {
        return context.navigator.cpuClass || null;
    }
    return navigator.cpuClass || null;
}
// Get platform
function getPlatform(context) {
    var _context_navigator;
    return (context == null ? void 0 : (_context_navigator = context.navigator) == null ? void 0 : _context_navigator.platform) || navigator.platform || "";
}
// Get plugins
function getPlugins(context) {
    var _context_navigator;
    const pluginsObj = (context == null ? void 0 : (_context_navigator = context.navigator) == null ? void 0 : _context_navigator.plugins) || navigator.plugins;
    if (!pluginsObj) return [];
    const plugins = [];
    for(let i = 0; i < pluginsObj.length; i++){
        const plugin = pluginsObj[i];
        plugins.push(plugin.name);
    }
    return plugins.sort();
}
// Get canvas fingerprint
function getCanvasFingerprint(context) {
    try {
        const doc = (context == null ? void 0 : context.document) || document;
        const canvas = doc.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) return "";
        // Canvas dimensions
        canvas.width = 240;
        canvas.height = 60;
        // Draw background
        ctx.fillStyle = "#f60";
        ctx.fillRect(0, 0, 240, 60);
        ctx.fillStyle = "#069";
        ctx.fillText("Quotient Fingerprinting", 2, 20);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("Quotient Fingerprinting", 4, 40);
        return canvas.toDataURL().slice(0, 100);
    } catch (e) {
        return "";
    }
}
// Get WebGL fingerprint
function getWebGLFingerprint(context) {
    try {
        const doc = (context == null ? void 0 : context.document) || document;
        const canvas = doc.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) return "";
        // Cast to WebGLRenderingContext to access WebGL-specific methods
        const webGl = gl;
        const extension = webGl.getExtension("WEBGL_debug_renderer_info");
        if (!extension) return "";
        return webGl.getParameter(extension.UNMASKED_RENDERER_WEBGL).toString().slice(0, 100);
    } catch (e) {
        return "";
    }
}
// Get WebGL vendor and renderer
function getWebGLVendorAndRenderer(context) {
    try {
        const doc = (context == null ? void 0 : context.document) || document;
        const canvas = doc.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) return "";
        // Cast to WebGLRenderingContext to access WebGL-specific methods
        const webGl = gl;
        const extension = webGl.getExtension("WEBGL_debug_renderer_info");
        if (!extension) return "";
        const vendor = webGl.getParameter(extension.UNMASKED_VENDOR_WEBGL) || "";
        const renderer = webGl.getParameter(extension.UNMASKED_RENDERER_WEBGL) || "";
        return `${vendor}~${renderer}`;
    } catch (e) {
        return "";
    }
}
// Get common fonts
function getCommonFonts(context) {
    if (!(context == null ? void 0 : context.document) && typeof document === "undefined") return [];
    const doc = (context == null ? void 0 : context.document) || document;
    const fontList = [
        "Arial",
        "Arial Black",
        "Arial Narrow",
        "Calibri",
        "Cambria",
        "Cambria Math",
        "Comic Sans MS",
        "Consolas",
        "Courier",
        "Courier New",
        "Georgia",
        "Helvetica",
        "Impact",
        "Lucida Console",
        "Lucida Sans Unicode",
        "Microsoft Sans Serif",
        "Palatino Linotype",
        "Segoe UI",
        "Tahoma",
        "Times",
        "Times New Roman",
        "Trebuchet MS",
        "Verdana"
    ];
    // Create span element to test fonts
    const testString = "mmmmmmmmmmlli";
    const h = doc.getElementsByTagName("body")[0];
    const baseFonts = [
        "monospace",
        "sans-serif",
        "serif"
    ];
    const testSize = "72px";
    if (!h) return [];
    // Create baseline elements to compare against
    const baselineWidths = {};
    const baselineHeights = {};
    for (const baseFont of baseFonts){
        const s = doc.createElement("span");
        s.style.fontSize = testSize;
        s.style.fontFamily = baseFont;
        s.textContent = testString;
        h.appendChild(s);
        baselineWidths[baseFont] = s.offsetWidth;
        baselineHeights[baseFont] = s.offsetHeight;
        h.removeChild(s);
    }
    const detected = [];
    for (const font of fontList){
        let isDetected = false;
        for (const baseFont of baseFonts){
            const s = doc.createElement("span");
            s.style.fontSize = testSize;
            s.style.fontFamily = `${font}, ${baseFont}`;
            s.textContent = testString;
            h.appendChild(s);
            // If width/height doesn't match baseline, font likely exists
            if (s.offsetWidth !== baselineWidths[baseFont] || s.offsetHeight !== baselineHeights[baseFont]) {
                isDetected = true;
            }
            h.removeChild(s);
            if (isDetected) break;
        }
        if (isDetected) detected.push(font);
    }
    return detected.sort();
}
// Get audio fingerprint
function getAudioFingerprint(context) {
    try {
        const win = (context == null ? void 0 : context.window) || window;
        // Use type assertion for the window object
        const winWithAudio = win;
        const AudioContext = winWithAudio.AudioContext || winWithAudio.webkitAudioContext;
        if (!AudioContext) return "";
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const oscillator = audioContext.createOscillator();
        const dynamicsCompressor = audioContext.createDynamicsCompressor();
        dynamicsCompressor.threshold.value = -50;
        dynamicsCompressor.knee.value = 40;
        dynamicsCompressor.ratio.value = 12;
        dynamicsCompressor.attack.value = 0;
        dynamicsCompressor.release.value = 0.25;
        analyser.fftSize = 1024;
        oscillator.type = "triangle";
        oscillator.frequency.value = 10000;
        oscillator.connect(dynamicsCompressor);
        dynamicsCompressor.connect(analyser);
        analyser.connect(audioContext.destination);
        oscillator.start(0);
        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(dataArray);
        oscillator.stop();
        audioContext.close();
        // Create a simple hash from the audio data
        return Array.from(dataArray.slice(0, 10)).join(",");
    } catch (e) {
        return "";
    }
}
// Get touch support
function getTouchSupport(context) {
    const nav = (context == null ? void 0 : context.navigator) || navigator;
    const win = (context == null ? void 0 : context.window) || window;
    return {
        maxTouchPoints: nav.maxTouchPoints || 0,
        touchEvent: "ontouchstart" in win,
        touchStart: Boolean(win.TouchEvent)
    };
}
// Collect all fingerprint components
function collectComponents(options = {}) {
    const { detectScreenOrientation = true, includeAudio = true, includeCanvas = true, includeWebGL = true, includeFonts = true, context = {
        document: typeof document !== "undefined" ? document : undefined,
        navigator: typeof navigator !== "undefined" ? navigator : undefined,
        window: typeof window !== "undefined" ? window : undefined
    } } = options;
    return {
        userAgent: getUserAgent(context),
        language: getLanguage(context),
        colorDepth: getColorDepth(context),
        deviceMemory: getDeviceMemory(context),
        hardwareConcurrency: getHardwareConcurrency(context),
        screenResolution: getScreenResolution(detectScreenOrientation, context),
        availableScreenResolution: getAvailableScreenResolution(detectScreenOrientation, context),
        timezoneOffset: getTimezoneOffset(),
        timezone: getTimezone(),
        sessionStorage: hasSessionStorage(context),
        localStorage: hasLocalStorage(context),
        indexedDb: hasIndexedDB(context),
        cpuClass: getCpuClass(context),
        platform: getPlatform(context),
        plugins: getPlugins(context),
        canvas: includeCanvas ? getCanvasFingerprint(context) : "",
        webgl: includeWebGL ? getWebGLFingerprint(context) : "",
        webglVendorAndRenderer: includeWebGL ? getWebGLVendorAndRenderer(context) : "",
        fonts: includeFonts ? getCommonFonts(context) : [],
        audio: includeAudio ? getAudioFingerprint(context) : "",
        touchSupport: getTouchSupport(context)
    };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Creates a unique browser fingerprint.
 * @param options Fingerprinting options
 * @returns A promise that resolves to a fingerprint object
 */ function createFingerprint() {
    return _createFingerprint.apply(this, arguments);
}
function _createFingerprint() {
    _createFingerprint = _async_to_generator(function*(options = {}) {
        const components = collectComponents({
            detectScreenOrientation: options.detectScreenOrientation,
            includeAudio: options.includeAudio,
            includeCanvas: options.includeCanvas,
            includeWebGL: options.includeWebGL,
            includeFonts: options.includeFonts,
            context: options.context
        });
        // Filter out excluded components
        const filteredComponents = _extends({}, components);
        if (options.excludeComponents) {
            for (const component of options.excludeComponents){
                if (component in filteredComponents) {
                    // @ts-ignore - we're checking if the key exists
                    delete filteredComponents[component];
                }
            }
        }
        // Create hash from components using Web Crypto API
        const hash = yield hashComponents(filteredComponents);
        return {
            hash,
            components,
            createdAt: new Date().toISOString()
        };
    });
    return _createFingerprint.apply(this, arguments);
}
/**
 * Creates a SHA-256 hash from fingerprint components using Web Crypto API.
 * @param components The fingerprint components
 * @returns A promise that resolves to a hash string
 */ function hashComponents(components) {
    return _hashComponents.apply(this, arguments);
}
function _hashComponents() {
    _hashComponents = _async_to_generator(function*(components) {
        // Convert components to a string
        const stringifiedComponents = JSON.stringify(sortObjectKeys(components));
        // Encode the string as UTF-8
        const encoder = new TextEncoder();
        const data = encoder.encode(stringifiedComponents);
        // Create SHA-256 hash using Web Crypto API
        const hashBuffer = yield crypto.subtle.digest("SHA-256", data);
        // Convert buffer to hex string
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    });
    return _hashComponents.apply(this, arguments);
}
/**
 * Sorts object keys alphabetically for consistent hashing.
 * @param obj Object to sort
 * @returns New object with sorted keys
 */ function sortObjectKeys(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortObjectKeys);
    }
    return Object.keys(obj).sort().reduce((result, key)=>{
        result[key] = sortObjectKeys(obj[key]);
        return result;
    }, {});
}
/**
 * Calculates similarity between two fingerprints.
 * @param fp1 First fingerprint
 * @param fp2 Second fingerprint
 * @returns Similarity score (0-1)
 */ function calculateSimilarity(fp1, fp2) {
    const components1 = fp1.components;
    const components2 = fp2.components;
    const totalComponents = Object.keys(components1).length;
    let matchingComponents = 0;
    // Compare each component
    for (const key of Object.keys(components1)){
        const value1 = components1[key];
        const value2 = components2[key];
        if (key === "fonts" || key === "plugins") {
            // For arrays, calculate Jaccard similarity
            const set1 = new Set(value1);
            const set2 = new Set(value2);
            if (set1.size === 0 && set2.size === 0) {
                matchingComponents += 1;
                continue;
            }
            // Calculate intersection size
            const intersection = new Set([
                ...set1
            ].filter((x)=>set2.has(x)));
            const union = new Set([
                ...set1,
                ...set2
            ]);
            // Partial match based on Jaccard similarity
            matchingComponents += intersection.size / union.size;
        } else if (key === "touchSupport") {
            // For objects, check each property
            const touch1 = value1;
            const touch2 = value2;
            let touchMatches = 0;
            const touchProps = Object.keys(touch1);
            for (const prop of touchProps){
                if (touch1[prop] === touch2[prop]) {
                    touchMatches++;
                }
            }
            matchingComponents += touchMatches / touchProps.length;
        } else {
            // Direct comparison for other values
            if (value1 === value2) {
                matchingComponents++;
            }
        }
    }
    return matchingComponents / totalComponents;
}
/**
 * Determines if two fingerprints are likely from the same browser.
 * @param fp1 First fingerprint
 * @param fp2 Second fingerprint
 * @param threshold Similarity threshold (0-1), defaults to 0.85
 * @returns True if fingerprints match
 */ function isSameFingerprint(fp1, fp2, threshold = 0.85) {
    // If hashes match, they're definitely the same
    if (fp1.hash === fp2.hash) return true;
    // Otherwise, check if the components are similar enough
    const similarity = calculateSimilarity(fp1, fp2);
    return similarity >= threshold;
}

export { calculateSimilarity, collectComponents, createFingerprint, getAudioFingerprint, getAvailableScreenResolution, getCanvasFingerprint, getColorDepth, getCommonFonts, getCpuClass, getDeviceMemory, getHardwareConcurrency, getLanguage, getPlatform, getPlugins, getScreenResolution, getTimezone, getTimezoneOffset, getTouchSupport, getUserAgent, getWebGLFingerprint, getWebGLVendorAndRenderer, hasIndexedDB, hasLocalStorage, hasSessionStorage, hashComponents, isSameFingerprint };
